"use client";

import React from "react";
import { Search, Target, Cog, Headset, ArrowRight } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Furniture Removal",
  description: "Effortless disposal of old sofas, tables, and cabinets. We handle the heavy lifting and ensure responsible recycling.",
  icon: Search,
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/furniture_removal.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/furniture_removal.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/furniture_removal.png-wvc-sizes",
    alt: "Furniture Removal Service"
  },
  link: "#"
}, {
  title: "Appliance Removal",
  description: "Safe removal of refrigerators, washers, and dryers. We follow strict environmental guidelines for electronic waste.",
  icon: Target,
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/appliance_disposal.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/appliance_disposal.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/appliance_disposal.png-wvc-sizes",
    alt: "Appliance Removal Service"
  },
  link: "#"
}, {
  title: "Mattress Disposal",
  description: "Hygienic and quick mattress hauling. We partner with local facilities to recycle components and reduce landfill waste.",
  icon: Cog,
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/mattress_hauling.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/mattress_hauling.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/mattress_hauling.png-wvc-sizes",
    alt: "Mattress Disposal Service"
  },
  link: "#"
}, {
  title: "Garage Cleanouts",
  description: "Reclaim your space with our full-service garage clearing. We sort, haul, and sweep up so you don't have to.",
  icon: Headset,
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/garage_cleanout.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/garage_cleanout.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/garage_cleanout.png-wvc-sizes",
    alt: "Garage Cleanout Service"
  },
  link: "#"
}];
export default function ServicesGrid() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="260456" id="services-grid" className="py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Our Junk Removal Services
          </h2>
          <div className="w-24 h-1 bg-secondary mx-auto mb-6 rounded-md"></div>
          <p className="font-default text-lg text-muted-foreground">
            Professional hauling solutions for your home and business. We make clearing out clutter simple, fast, and eco-friendly.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={i} data-index={i} className="group relative overflow-hidden border-border hover:border-secondary transition-all duration-300 shadow-md hover:shadow-lg flex flex-col h-full bg-card rounded-lg">
                <div className="relative w-full h-48 overflow-hidden">
                  <img src={service.image.src} data-wvc-srcset={service.image.srcset} data-wvc-sizes={service.image.sizes} alt={service.image.alt} className="object-cover w-full h-full group-hover:scale-105 transition-transform duration-500" loading="lazy" />
                  <div className="absolute inset-0 bg-black/10 group-hover:bg-transparent transition-colors duration-300"></div>
                  <div className="absolute -bottom-6 left-6 bg-card p-3 rounded-lg border border-border shadow-sm text-secondary group-hover:bg-secondary group-hover:text-secondary-foreground transition-colors duration-300 z-10">
                    <Icon className="w-6 h-6" />
                  </div>
                </div>

                <CardHeader className="pt-10 pb-2">
                  <CardTitle className="font-default text-xl font-bold text-foreground group-hover:text-primary transition-colors duration-300">
                    {service.title}
                  </CardTitle>
                  <div className="w-12 h-1 bg-secondary rounded-md mt-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </CardHeader>

                <CardContent className="flex-grow flex flex-col justify-between">
                  <p className="font-default text-muted-foreground mb-6">
                    {service.description}
                  </p>
                  <Link to={service.link} className="inline-flex items-center text-sm font-bold text-primary hover:text-secondary transition-colors duration-200 mt-auto w-fit bg-secondary/10 px-4 py-2 rounded-lg">
                    Book Now
                    <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform duration-200" />
                  </Link>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}